import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator'

@Component({
	selector: 'app-list-paginator',
	standalone: true,
	imports: [MatPaginatorModule],
	templateUrl: './list-paginator.component.html',
	styleUrl: './list-paginator.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListPaginatorComponent {
	readonly length = input.required<number>()
	readonly pageSize = input<number>(10)
	readonly pageIndex = input<number>(0)
	readonly disabled = input<boolean>(false)
	readonly hidePageSize = input<boolean>(true)
	readonly visible = input<boolean>(true)

	readonly pageChange = output<PageEvent>()
}
